<template>
  <section
    v-if="value !== null"
    class="data pega-print-break-inside-avoid"
  >
    <p class="hd-type-04 mr5">
      <span>{{ title }}</span>
    </p>
    <job-preview-content-data-tooltip-sp />
    <div class="palette">
      <div
        class="colorOuter"
        :class="colorClass"
      >
        <div
          class="colorInner"
          :style="`transform: rotate(${rotateTurn}turn);`"
        />
      </div>
      <div class="centerOverlay fwB">
        <span class="head">女性</span>
        <span class="half tr">{{ value }}</span>
        <span class="half">％</span>
        <div class="north" />
        <div
          class="separator"
          :style="`transform: rotate(${rotateTurn}turn) translate(0px, -50px);`"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import JobPreviewContentDataTooltipSp from '@/components/atoms/JobPreviewContentDataTooltipSp'
import jobPreviewGraph from '@/lib/jobPreviewGraph'

export default {
  components: {
    JobPreviewContentDataTooltipSp
  },
  mixins: [jobPreviewGraph],
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default: null
    }
  }
}
</script>
